import cameraProperties from 'schemas/legacy/helpers/cameraProperties'

export default function legacy(project) {
  return {
    type: 'object',
    properties: {
      zoom: { type: ['integer', 'string'] },
      bounds: { type: 'array' },
      mode: { type: 'string' },
      cameras: cameraProperties(project),
      markups: {
        type: 'object',
        patternProperties: {
          '[0-9]+': {
            oneOf: [
              {
                type: 'object',
                properties: {
                  type: {
                    type: 'string',
                    enum: ['polygon']
                  },
                  strokeColor: { type: 'string' },
                  locked: { type: ['string', 'boolean'] },
                  fillColor: { type: 'string' },
                  paths: {
                    type: 'object',
                    patternProperties: {
                      '[0-9]+': {
                        type: 'object',
                        properties: {
                          lat: { type: ['string', 'number'] },
                          lng: { type: ['string', 'number'] }
                        },
                        required: ['lat', 'lng']
                      }
                    }
                  }
                },
                required: ['fillColor', 'paths', 'locked']
              },
              {
                type: 'object',
                properties: {
                  type: {
                    type: 'string',
                    enum: ['rectangle']
                  },
                  strokeColor: { type: 'string' },
                  locked: { type: ['string', 'boolean'] },
                  fillColor: { type: 'string' },
                  position: {
                    type: 'object',
                    properties: {
                      ne: {
                        type: 'object',
                        properties: {
                          lat: { type: ['string', 'number'] },
                          lng: { type: ['string', 'number'] }
                        },
                        required: ['lat', 'lng']
                      },
                      sw: {
                        type: 'object',
                        properties: {
                          lat: { type: ['string', 'number'] },
                          lng: { type: ['string', 'number'] }
                        },
                        required: ['lat', 'lng']
                      }
                    },
                    required: ['ne', 'sw']
                  },
                  required: ['fillColor', 'position', 'locked']
                }
              },
              {
                type: 'object',
                properties: {
                  type: {
                    type: 'string',
                    enum: ['circle']
                  },
                  strokeColor: { type: 'string' },
                  locked: { type: ['string', 'boolean'] },
                  fillColor: { type: 'string' },
                  position: {
                    type: 'object',
                    properties: {
                      center: {
                        type: 'object',
                        properties: {
                          lat: { type: ['string', 'number'] },
                          lng: { type: ['string', 'number'] }
                        },
                        required: ['lat', 'lng']
                      },
                      radius: { type: ['string', 'number'] }
                    },
                    required: ['center', 'radius']
                  }
                },
                required: ['fillColor', 'position', 'locked']
              },
              {
                type: 'object',
                properties: {
                  type: {
                    type: 'string',
                    enum: ['polyline']
                  },
                  locked: { type: ['string', 'boolean'] },
                  path: {
                    type: 'object',
                    patternProperties: {
                      '[0-9]+': {
                        type: 'object',
                        properties: {
                          lat: { type: ['string', 'number'] },
                          lng: { type: ['string', 'number'] }
                        },
                        required: ['lat', 'lng']
                      }
                    }
                  }
                },
                required: ['path', 'locked']
              },
              {
                type: 'object',
                properties: {
                  type: {
                    type: 'string',
                    enum: ['label']
                  },
                  locked: { type: ['boolean', 'string'] },
                  strokeColor: { type: 'string' },
                  text: { type: 'string' },
                  fillColor: { type: 'string' },
                  dimensions: {
                    type: 'object',
                    properties: {
                      width: { type: ['string', 'number'] },
                      height: { type: ['string', 'number'] },
                      baseFontSize: { type: ['string', 'number'] }
                    },
                    required: ['width', 'height']
                  },
                  position: {
                    type: 'object',
                    properties: {
                      lat: { type: ['string', 'number'] },
                      lng: { type: ['string', 'number'] }
                    },
                    required: ['lat', 'lng']
                  }
                },
                required: ['fillColor', 'text', 'dimensions', 'position']
              }
            ]
          }
        },
        additionalProperties: false
      },
      floor_plans: {
        type: 'object',
        additionalProperties: false,
        patternProperties: {
          '[0-9]+': {
            type: 'object',
            properties: {
              id: { type: ['string', 'integer'] },
              imageSrc: { type: 'string' },
              imageSize: {
                type: 'object',
                properties: {
                  width: { type: ['string', 'integer'] },
                  height: { type: ['string', 'integer'] }
                },
                required: ['width', 'height']
              },
              position: {
                type: 'object',
                properties: {
                  nw: {
                    type: 'object',
                    properties: {
                      lat: { type: ['string', 'number'] },
                      lng: { type: ['string', 'number'] }
                    },
                    required: ['lat', 'lng']
                  },
                  se: {
                    type: 'object',
                    properties: {
                      lat: { type: ['string', 'number'] },
                      lng: { type: ['string', 'number'] }
                    },
                    required: ['lat', 'lng']
                  }
                },
                required: ['nw', 'se']
              },
              lock: { type: ['string', 'boolean'] },
              scale: { type: ['string', 'boolean'] }
            },
            required: ['id', 'imageSrc', 'imageSize', 'position', 'lock', 'scale']
          }
        }
      },
      width: { type: ['integer', 'string'] },
      height: { type: ['integer', 'string'] }
    },
    required: ['zoom', 'bounds', 'cameras', 'width', 'height']
  }
}



// WEBPACK FOOTER //
// ./src/schemas/legacy/index.js